// extracted by mini-css-extract-plugin
export default {"productGrid":"I1-z","centerLink":"J1-z","productSection":"K1-z","item":"L1-z","ctaButton":"M1-z"};